import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";

/**
 * Created by Jerker Nord on 2019-07-02.
 */

export class ThorScatterNearWinReelStopController extends ReelStopPresentationController {

    private _scatterCounter:number;
    private _checkForNearWinScatters:boolean;
    private _reels:string[][];

    constructor(index:number) {
        super(index, "ThorScatterNearWinReelStopController");
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            this._checkForNearWinScatters = true;
            this._scatterCounter = 0;
        } else {
            this._checkForNearWinScatters = false;
        }
        this._reels = data.reels;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._checkForNearWinScatters) {
            if(this._scatterCounter < 2) {
                for(let i:number = 3; i < 6; i++) {
                    if(this._reels[data.reelId][i] == "S") {
                        this._scatterCounter++;
                        break;
                    }
                }
            }
            if(this._scatterCounter >= 2) {
                let startReelId:number = data.reelId + 1;
                if(startReelId <= 4) {
                    ThorGameModuleConfig.thorScatterNearWinView.enableScatterAnimation(startReelId, false);
                }
            }
        }
        ThorGameModuleConfig.thorScatterNearWinView.disableScatterAnimation(data.reelId);
        this.dispatchCompleteEvent(data.reelId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }
}